// extracted by mini-css-extract-plugin
export default {"container":"TermsPrivacyPage_container__hdP3L","section":"TermsPrivacyPage_section__n-gaI","effectiveDate":"TermsPrivacyPage_effectiveDate__RbO0C"};